import { render, staticRenderFns } from "./gzjh.vue?vue&type=template&id=26d1ec2a&scoped=true"
import script from "./gzjh.vue?vue&type=script&lang=js"
export * from "./gzjh.vue?vue&type=script&lang=js"
import style0 from "./gzjh.vue?vue&type=style&index=0&id=26d1ec2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d1ec2a",
  null
  
)

export default component.exports